const MONTH_IN_A_YEAR = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sept', 'Octo', 'Nove', 'Dec'
];
function getInDate(date, prefomattedDate = false, hideYear = false) {
    const day = date.getDate();
    const month = MONTH_IN_A_YEAR[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    let minutes = date.getMinutes();
    if (minutes < 10) {
        // leading zero to minutes
        minutes = `0${minutes}`;
    }
    if (prefomattedDate) {
        // Today || Yesterday
        return `${prefomattedDate} at ${hours}:${minutes}`;
    }
    if (hideYear) {
        return `${day}. ${month} at ${hours}:${minutes}`;
    }
    return `${day}. ${month} ${year}. at ${hours}:${minutes}`;
}


export default function timeAgo(dateParam) {
    if (!dateParam) {
        return null;
    }
    const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);
    const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
    const today = new Date();
    const yesterday = new Date(today - DAY_IN_MS);
    const seconds = Math.round((today - date) / 1000);
    const minutes = Math.round(seconds / 60);
    const isToday = today.toDateString() === date.toDateString();
    const isYesterday = yesterday.toDateString() === date.toDateString();
    const isThisYear = today.getFullYear() === date.getFullYear();
    if (seconds < 5) {
        return 'now';
    }
    else if (seconds < 60) {
        return `${seconds} seconds ago`;
    }
    else if (seconds < 90) {
        return 'about a minute ago';
    }
    else if (minutes < 60) {
        return `${minutes} minutes ago`;
    }
    else if (isToday) {
        return getInDate(date, 'Today');
    }
    else if (isYesterday) {
        return getInDate(date, 'Yesterday');
    }
    else if (isThisYear) {
        return getInDate(date, false, true);
    }
    return getInDate(date);
}
// // --- DEMO
// const minuteInMs = 60000;
// const hourInMs = minuteInMs * 60;
// const dayInMs = hourInMs * 24;
// const dates = [
//     new Date(),
//     new Date(new Date().getTime() - minuteInMs),
//     new Date(new Date().getTime() - minuteInMs * 45),
//     new Date(new Date().getTime() - hourInMs),
//     new Date(new Date().getTime() - hourInMs * 24),
//     new Date(new Date().getTime() - dayInMs * 5),
// ];
// dates.forEach(date => {
//     document.querySelector('.demo').innerHTML +=
//         `<div>
//       <span class="locale-string">${date.toLocaleString()}</span>
//       <span class="arrow">→</span>
//       <span class="time-ago">${timeAgo(date)}</span>
//     </div>`;
// });
